import * as React from "react";
import Moment from 'react-moment';

function createTextLinks(text) {    
    return (text || "").replace(
        /([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi,
        function(match, space, url){
            var hyperlink = url;
            if (!hyperlink.match('^https?:\/\/')) {
                hyperlink = 'http://' + hyperlink;
            }
            return space + '<a target="_blank" href="' + hyperlink + '">' + url + '</a>';
        }
    );    
};

class Messages extends React.Component <any,any> {
    messagesEnd:any
    messagesList:any
    searchInput:any
    clearButton:any
    constructor(props) {
        super(props);
        this.state = {
            filterMessages:false,
            searchText:"",
            lastFilteredMessage:null,
        };
    }
    filterMessages() {
        let lastFilteredMessage;
        let messageCount = this.props.messages.length;
        if(messageCount) {
            lastFilteredMessage = this.props.messages[messageCount - 1];
        } else {
            lastFilteredMessage = null;
        }
        this.setState({
            filterMessages:true,
            lastFilteredMessage:lastFilteredMessage,
            searchText: this.searchInput.value,
        });
        if(this.searchInput.value) {
            this.clearButton.style.visibility = 'visible';
        } else {
            this.clearButton.style.visibility = 'hidden';
        }
    }
    search() {
        this.filterMessages();
    }
    onSubmit(e) {
        this.filterMessages();
        e.preventDefault();
    }
    clear() {
        this.searchInput.value = "";        
        this.setState({filterMessages:false,searchText:""});
        this.clearButton.style.visibility = 'hidden';
    }
    render() {
        const {messages} = this.props;
        return (
            <React.Fragment>
                <div className="search-form-container">
                    <form className="search-form" onSubmit={e => {this.onSubmit(e)}}>
                        <span className="search-input-wrapper">
                            <input placeholder="Search in messages" className="search-input" type="text" ref={(el) => {this.searchInput=el; }} />
                            <span ref={(el) => {this.clearButton = el;}}  onClick={e => {this.clear()}} className="clear">&times;</span>
                        </span>
                        <input className="search-button" type="button" value="Search" onClick={() => this.search()}/>
                    </form>
                </div>
                <div className="search-info" >{(this.state.filterMessages && this.state.searchText != "") ? "Search text: " + this.state.searchText : ""}</div>
                <ul ref={(el) => { this.messagesList = el;}}  className="messages">
                    {messages.map(m => this.renderMessage(m))}
                    <div ref={(el) => { this.messagesEnd = el;}}/>
                </ul>
            </React.Fragment>
        );
    }
    deleteMessage(messageId) {
        this.props.deleteMessage(messageId);
    }
    componentDidUpdate() {
        this.messagesList.scrollTop = this.messagesEnd.offsetTop;
    }
    componentDidMount() {        
        // componentDidUpdate doesn't fire in release version of the app
        setTimeout(() => {
            this.messagesList.scrollTop = this.messagesEnd.offsetTop;
        },200);
    }
    renderMessage(message) {
        const {id,text, senderId, createdAt} = message;
        const {currentUser} = this.props;
        const messageFromMe = currentUser.id === message.senderId;
        const className = messageFromMe ? "message currentMember" : "message";                
        
        /* console.log('this.state.filterMessages');
         * console.log(this.state.filterMessages);
         * console.log('query');
         * console.log(query);
         * console.log('this.state.lastFilteredMessage');
         * console.log(this.state.lastFilteredMessage);
         * console.log('createdAt');
         * console.log(createdAt);
         * console.log('text');
         * console.log(text); */                
        
        if(this.state.filterMessages
           && this.state.searchText
           && this.state.lastFilteredMessage
           && createdAt <= this.state.lastFilteredMessage.createdAt
        ) {
            if(text.toLowerCase().search(this.state.searchText.toLowerCase()) === -1) {
                return;
           }
        }

        const textWithLinks = createTextLinks(text);
        
        let username;
        let avatar;
        let deleteMessageButton;
        if(messageFromMe) {
            deleteMessageButton = <div><a onClick={(e)=> this.deleteMessage(id)} className="deleteMessage" href="#">Delete</a></div>;
            if(currentUser.name) {
                username = currentUser.name;
            } else {
                username = currentUser.email;
            }
            if (currentUser.image_src) {
                avatar = <img className="avatar" src={currentUser.image_src} />;
            } else {
                avatar = <span className="placeholder" style={{backgroundColor: "red"}} />;
            }
        } else {
            const user = this.props.users[senderId];
            if(user) {
                if(user.name) {
                    username = user.name;
                } else {
                    username = user.email;
                }
                if (user.image_src) {
                    avatar = <img className="avatar" src={user.image_src} />;
                } else {
                    avatar = <span className="placeholder" style={{backgroundColor: "blue"}} />;
                }
            }
        }
        return (
            <li className={className} key={id}>
                {avatar}
                <div className="messageContent">
                    <div className="username">
                        {username}
                    </div>
                    <div className="text">
                        <div dangerouslySetInnerHTML={{__html:textWithLinks}}/>
                        <div>{deleteMessageButton}</div>
                    </div>
                    <div>
                        <Moment format="HH:mm:ss DD/MM/YYYY">
                            {createdAt}
                        </Moment>
                    </div>
                </div>
            </li>
        );
    }
}

export default Messages;
